export * from "./master-rooms.component";
